import { IconProps } from '@sternum/web/icons/icons.types';

export function DocumentDownloadIcon({ width = 24, height = 24, ...rest }: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.48837 10.5349C9.83515 10.5349 10.1163 10.816 10.1163 11.1628V14.6702L10.7188 14.0676C10.964 13.8224 11.3616 13.8224 11.6068 14.0676C11.852 14.3128 11.852 14.7104 11.6068 14.9556L9.93236 16.63C9.75278 16.8096 9.48271 16.8633 9.24808 16.7662C9.01344 16.669 8.86046 16.44 8.86046 16.1861V11.1628C8.86046 10.816 9.14158 10.5349 9.48837 10.5349Z"
        fill="#818799"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.36995 14.0676C7.61516 13.8224 8.01273 13.8224 8.25795 14.0676L9.93236 15.7421C10.1776 15.9873 10.1776 16.3848 9.93236 16.63C9.68715 16.8753 9.28958 16.8753 9.04437 16.63L7.36995 14.9556C7.12474 14.7104 7.12474 14.3128 7.36995 14.0676Z"
        fill="#818799"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.43237 5.43239C4.66588 6.19888 4.25581 7.45729 4.25581 9.48838V14.5116C4.25581 16.5427 4.66588 17.8011 5.43237 18.5676C6.19886 19.3341 7.45727 19.7442 9.48837 19.7442H14.5116C16.5427 19.7442 17.8011 19.3341 18.5676 18.5676C19.3341 17.8011 19.7442 16.5427 19.7442 14.5116V10.3256C19.7442 9.97881 20.0253 9.69769 20.3721 9.69769C20.7189 9.69769 21 9.97881 21 10.3256V14.5116C21 16.6666 20.5728 18.3384 19.4556 19.4556C18.3384 20.5729 16.6666 21 14.5116 21H9.48837C7.33342 21 5.6616 20.5729 4.54437 19.4556C3.42714 18.3384 3 16.6666 3 14.5116V9.48838C3 7.33343 3.42714 5.66162 4.54437 4.54439C5.6616 3.42716 7.33342 3.00002 9.48837 3.00002H13.6744C14.0212 3.00002 14.3023 3.28114 14.3023 3.62792C14.3023 3.97471 14.0212 4.25583 13.6744 4.25583H9.48837C7.45727 4.25583 6.19886 4.66589 5.43237 5.43239Z"
        fill="#818799"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4341 3.04781C13.6688 2.95063 13.9388 3.00435 14.1184 3.18393L20.8161 9.8816C20.9957 10.0612 21.0494 10.3312 20.9522 10.5659C20.855 10.8005 20.626 10.9535 20.3721 10.9535H17.0232C15.7326 10.9535 14.6724 10.7465 13.963 10.037C13.2535 9.32756 13.0465 8.26736 13.0465 6.97676V3.62792C13.0465 3.37396 13.1995 3.145 13.4341 3.04781ZM14.3023 5.14382V6.97676C14.3023 8.19779 14.5139 8.812 14.851 9.14904C15.188 9.48608 15.8022 9.69769 17.0232 9.69769H18.8562L14.3023 5.14382Z"
        fill="#818799"
      />
    </svg>
  );
}
